module.exports = __webpack_public_path__ + "media/images/icons/facebook-black-4b1b5d2279649799e63982ca56256f62.svg";